<template>
    <div class="col-12">
        <confirm-box ref="error" :noConfirm="true"></confirm-box>

        <div class="row">
            <h4 v-if="id" class="text-primary">Editing {{ classItem.name }}</h4>
            <h4 v-else class="text-primary">New Class</h4>

            <div class="mb-3 col-12 col-lg-6">
                <label for="class-name-input">Class name</label>
                <input type="text" v-model="name" placeholder="Class name" class="form-control" id="class-name-input">
            </div>

            <div class="mb-3 col-12 col-lg-6">
                <label for="grading-period-input">Grading period</label>
                <input type="text" v-model="grading_period" placeholder="Grading period" class="form-control" id="grading-period-input">
            </div>

            <div class="mb-3 col-12 col-lg-6">
                <label for="district-input">District</label>
                <select v-model="district" class="form-control" id="district-input">
                    <option v-for="(dist, index) in districts" :value="dist.id">{{ dist.name }}</option>
                </select>
            </div>

            <div>
                <fieldset class="form-check form-switch mb-4">
                    <input v-model="status" class="form-check-input" type="checkbox" id="status-switch" >
                    <label class="form-check-label" for="status-switch">Active</label>
                </fieldset>
            </div>
        </div>
        <div class="col-12 mb-2">
            <cancel-submit-button
                :submit-text="id ? 'Submit' : 'Create'"
                :submit-icon="id ? 'fas fa-user-check' : 'fas fa-users'"
                :submit-disabled="!canCreate"
                @submit="id ? submit() : create()"
                @cancel="cancel()"
            ></cancel-submit-button>
        </div>
    </div>
</template>

<script>
import ConfirmBox from './ConfirmBox.vue';
import CancelSubmitButton from './CancelSubmitButton.vue';

export default {
    components: { ConfirmBox, CancelSubmitButton },

    props: {
        districts: {
            type: Array,
            default(data=[]) {
                return data;
            }
        },

        classItem: {
            type: Object,
            default(data={}) {
                return {
                    id: data.id ?? null,
                    name: data.name ?? '',
                    grading_period: data.grading_period ?? '',
                    district_id: data.district_id ?? null,
                    status: data.status ?? 1
                }
            }
        },

        index: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            id: this.classItem.id,
            name: this.classItem.name,
            grading_period: this.classItem.grading_period,
            district: this.classItem.district_id,
            status: this.classItem.status
        }
    },

    computed: {
        canCreate: function() {
            return Boolean(this.name && this.grading_period && this.district);
        },
    },

    methods: {
        create: function() {
            let data = {
                name: this.name,
                grading_period: this.grading_period,
                districts_id: this.district,
                status: this.status
            };

            this.$parent.isLoading = true;

            axios
                .post('/api/classes/create', data)
                .then((response) => {
                    this.$parent.classes = response.data.classes;

                    this.id = null;
                    this.name = '';
                    this.grading_period = '';
                    this.district = this.districts[0].id
                    this.status = 1;

                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.$refs.error.show({
                            title: 'Class Creation Error',
                            content: error.response.data.message,
                            callback: () => {},
                        });
                        console.error(error.response);
                    } else {
                        console.error(error);                        
                    }
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                })
        },

        submit: function() {
            let data = {
                name: this.name,
                grading_period: this.grading_period,
                districts_id: this.district,
                status: this.status
            };

            this.$parent.isLoading = true;

            axios
                .patch(`/api/classes/update/${this.id}`, data)
                .then((response) => {
                    this.$parent.editing = -1;
                    if (this.index !== null) {
                        this.$parent.classes = response.data.classes;
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.$refs.error.show({
                            title: 'Class Update Error',
                            content: error.response.data.message,
                            callback: () => {},
                        });
                    } else {
                        console.error(error);
                    }
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                })
        },

        cancel: function() {
            this.$parent.editing = -1;
        }
    },

    mounted() {
        // console.log(this.classItem);
        if (this.name == '') {
            let d = new Date();
            this.name = `New Class - ${d.toLocaleDateString()}`;
        }
    },

    updated() {
        if (this.districts.length > 0) {
            this.district = this.district ? this.district : this.districts[0].id;
        }
    }


}
</script>